import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { delay } from "rxjs/operators";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionProductionInfo } from "../../info/production/actionProductionInfo";
import { checkTutorialConstructClickBuildingMenu } from "../checks/checkTutorialConstructClickBuildingMenu";
import { checkTutorialHarvestClickAcre } from "../checks/checkTutorialHarvestClickAcre";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialQuestClickQuestMenu } from "../checks/checkTutorialQuestClickQuestMenu";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
import { pathTutorialUpdateViewport } from "../path/pathTutorialUpdateViewport";
export var epicTutorialOnProductionStart = function (action$, state$, deps) {
    var actionClickQuestMenu$ = action$.pipe(ofType(TypeActionProductionInfo.Start), delay(200), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialQuestClickQuestMenu])(pathTutorialUpdate),
    ]));
    var actionClickBuildingMenu$ = action$.pipe(ofType(TypeActionProductionInfo.Start), delay(200), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialConstructClickBuildingMenu,
        ])(pathTutorialUpdate),
    ]));
    var actionClickAcre$ = action$.pipe(ofType(TypeActionProductionInfo.Start), delay(200), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialHarvestClickAcre])(pathTutorialUpdateViewport),
    ]));
    return merge(actionClickAcre$, actionClickBuildingMenu$, actionClickQuestMenu$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialOnProductionStart.ts
// module id = 2487
// module chunks = 3